export default "__VITE_ASSET__6UXHN_Wv__"